import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ElectronicSignature\GetElectronicSignatureListController::__invoke
* @see app/Http/Controllers/ElectronicSignature/GetElectronicSignatureListController.php
* @route '/api/electronic-signature'
*/
const GetElectronicSignatureListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetElectronicSignatureListController.url(options),
    method: 'get',
})

GetElectronicSignatureListController.definition = {
    methods: ["get","head"],
    url: '/api/electronic-signature',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ElectronicSignature\GetElectronicSignatureListController::__invoke
* @see app/Http/Controllers/ElectronicSignature/GetElectronicSignatureListController.php
* @route '/api/electronic-signature'
*/
GetElectronicSignatureListController.url = (options?: RouteQueryOptions) => {
    return GetElectronicSignatureListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ElectronicSignature\GetElectronicSignatureListController::__invoke
* @see app/Http/Controllers/ElectronicSignature/GetElectronicSignatureListController.php
* @route '/api/electronic-signature'
*/
GetElectronicSignatureListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetElectronicSignatureListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ElectronicSignature\GetElectronicSignatureListController::__invoke
* @see app/Http/Controllers/ElectronicSignature/GetElectronicSignatureListController.php
* @route '/api/electronic-signature'
*/
GetElectronicSignatureListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetElectronicSignatureListController.url(options),
    method: 'head',
})

export default GetElectronicSignatureListController